(() => {
  if (customElements.get('jamila-product-description')) return;

  class JamilaProductDescription extends HTMLElement {
    connectedCallback() {
      if (this.enhanced) return;
      this.enhanced = true;
      this.querySelectorAll('h1').forEach((heading) => {
        if (heading.closest('jamila-product-description') !== this) return;
        const replacement = this.ownerDocument.createElement('h2');
        Array.from(heading.attributes).forEach((attribute) => replacement.setAttribute(attribute.name, attribute.value));
        while (heading.firstChild) replacement.append(heading.firstChild);
        heading.replaceWith(replacement);
      });
      this.enhanceLead();
      this.querySelectorAll('h2, h3, h4, h5, h6').forEach((heading) => {
        if (heading.closest('jamila-product-description') !== this) return;
        heading.classList.add('jpd-description__heading');
        if (/^(?:仕様|商品仕様|specifications)\s*[:：]?$/i.test(heading.textContent.trim())) {
          this.enhanceSpecifications(heading.nextElementSibling);
        }
      });
    }

    enhanceLead() {
      const first = Array.from(this.children).find((element) =>
        !element.matches('script, style, template') &&
        (element.textContent.trim() || element.querySelector('img, video, iframe'))
      );
      if (!first) return;
      const isParagraph = first.tagName === 'P' && first.textContent.trim();
      const isIntroHeading = first.tagName === 'H4' && Array.from(first.textContent.trim()).length >= 26;
      if (!isParagraph && !isIntroHeading) return;
      let lead = first;
      if (isIntroHeading) {
        lead = this.ownerDocument.createElement('p');
        Array.from(first.attributes).forEach((attribute) => lead.setAttribute(attribute.name, attribute.value));
        while (first.firstChild) lead.append(first.firstChild);
        first.replaceWith(lead);
      }
      lead.classList.add('jpd-description__lead');
    }

    specificationBoundary(item) {
      if (item.querySelector('ul, ol, dl, table, form, input, select, textarea, button, details, script, style, template')) return null;
      const text = item.textContent;
      const index = text.search(/[:：]/);
      if (index < 1) return null;
      const label = text.slice(0, index).trim();
      if (!label || Array.from(label).length > 32 || /[\n\r。！？!?]/.test(label)) return null;
      if (!text.slice(index + 1).trim() && !item.querySelector('img, video, audio, iframe, svg')) return null;
      const walker = this.ownerDocument.createTreeWalker(item, NodeFilter.SHOW_TEXT);
      let consumed = 0;
      for (let node = walker.nextNode(); node; node = walker.nextNode()) {
        if (index < consumed + node.data.length) {
          const offset = index - consumed + 1;
          if (node.parentElement.closest('a') && node.data.slice(offset).trim()) return null;
          return { node, offset };
        }
        consumed += node.data.length;
      }
      return null;
    }

    enhanceSpecifications(list) {
      if (!list || list.tagName !== 'UL' || list.hasAttribute('role')) return;
      const children = Array.from(list.childNodes);
      if (children.some((node) =>
        node.nodeType === Node.ELEMENT_NODE ? node.tagName !== 'LI' || node.hasAttribute('role') :
          node.nodeType === Node.TEXT_NODE && node.textContent.trim()
      )) return;
      const items = Array.from(list.children);
      if (!items.length) return;
      const boundaries = items.map((item) => this.specificationBoundary(item));
      if (boundaries.some((boundary) => !boundary)) return;
      const specifications = this.ownerDocument.createElement('dl');
      Array.from(list.attributes).forEach((attribute) => specifications.setAttribute(attribute.name, attribute.value));
      specifications.classList.add('jpd-description__specs');
      let itemIndex = 0;
      children.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) {
          specifications.append(node);
          return;
        }
        const boundary = boundaries[itemIndex++];
        const valueRange = this.ownerDocument.createRange();
        valueRange.selectNodeContents(node);
        valueRange.setStart(boundary.node, boundary.offset);
        const row = this.ownerDocument.createElement('div');
        Array.from(node.attributes).forEach((attribute) => row.setAttribute(attribute.name, attribute.value));
        row.classList.add('jpd-description__spec-row');
        const label = this.ownerDocument.createElement('dt');
        const value = this.ownerDocument.createElement('dd');
        value.append(valueRange.extractContents());
        while (node.firstChild) label.append(node.firstChild);
        row.append(label, value);
        specifications.append(row);
      });
      list.replaceWith(specifications);
    }
  }

  customElements.define('jamila-product-description', JamilaProductDescription);
})();
